import Head from "next/head";
// import { make as PerfectSynergiesPage } from "../src/tools/PerfectSynergiesPage.bs";
import PerfectSynergiesPage from "../src/tools/PerfectSynergiesPage.tsx";

export default function PerfectSynergies({ data }) {
  return (
    <>
      <Head>
        <title>Perfect Synergies Tool - TFT Set 17</title>
      </Head>
      <PerfectSynergiesPage data={data} />
    </>
  );
}
